<template>
  <v-card>
    <v-card-title>
      <span class="headline">{{ title }}</span>
    </v-card-title>
    <v-card-text>
      <v-container grid-list-md>
        <v-flex xs12>
          <form>
            <v-text-field
              label="Name"
              v-model="name"
              :error-messages="nameErrors"
              :counter="30"
              @input="$v.name.$touch()"
              @blur="$v.name.$touch()"
              prepend-icon="local_mall"
              required
            ></v-text-field>
            <v-text-field
              label="Short Name"
              v-model="shortName"
              :error-messages="shortNameErrors"
              :counter="10"
              @input="$v.shortName.$touch()"
              @blur="$v.shortName.$touch()"
              prepend-icon="short_text"
              required
            ></v-text-field>
            <v-layout align-center>
              <v-select
                label="Countries"
                v-model="countries"
                :items="countriesList"
                item-text="name"
                item-value="id"
                :error-messages="countriesErrors"
                @change="$v.countries.$touch()"
                @blur="$v.countries.$touch()"
                prepend-icon="map"
                multiple
                chips
                deletable-chips
                dark
                clearable
                autocomplete
                required
              ></v-select>
              <v-checkbox v-model="selectAllCheck" hide-details class="shrink mr-2"></v-checkbox>
              <span>Select All</span>
            </v-layout>
          </form>
        </v-flex>
        <small>*All fields is required</small>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="blue darken-1" flat @click="close">Close</v-btn>
      <v-btn color="blue darken-1" flat @click="save">Submit</v-btn>
    </v-card-actions>
    <v-snackbar
      :timeout="3000"
      :bottom="true"
      :right="true"
      :multi-line="false"
      v-model="snackBar"
    >
      {{ snackBarText }}
      <v-btn flat color="pink" @click.native="snackBar = false">Close</v-btn>
    </v-snackbar>
  </v-card>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, maxLength } from 'vuelidate/lib/validators'
import { COUNTRIES_LIST } from '../../store/actions/countries'
import { mapGetters } from 'vuex'

export default {
  mixins: [validationMixin],
  validations: {
    name: { required, maxLength: maxLength(30) },
    shortName: { required, maxLength: maxLength(10) },
    countries: { required }
  },
  props: ['title', 'distributorInit'],
  data: () => ({
    name: '',
    shortName: '',
    countries: [],
    snackBarText: 'Input is not valid!',
    snackBar: false,
    selectAllCheck: false
  }),
  methods: {
    save: async function () {
      this.name = this.name.trim()
      this.$v.$touch()
      if (this.$v.$error) {
        this.snackBar = true
        this.snackBarText = 'Input is not valid!'
        return
      }
      this.$emit('save', { name: this.name, countries: this.countries, shortName: this.shortName })
    },
    close: function () {
      this.clear()
      this.$emit('close')
    },
    clear: function () {
      this.$v.$reset()
      this.name = this.distributorInit.name || ''
      this.countries = (this.distributorInit.countries) ? this.distributorInit.countries.map(item => {
        return item.id
      }) : []
    },
    init: function (newDistributor) {
      this.name = newDistributor.name
      this.shortName = newDistributor.shortName
      this.countries = (newDistributor.countries) ? newDistributor.countries.map(item => {
        return item.id
      }) : []
    }
  },
  computed: {
    ...mapGetters({
      countriesList: 'countries'
    }),
    nameErrors () {
      const errors = []
      if (!this.$v.name.$dirty) return errors
      !this.$v.name.maxLength && errors.push('Name must be at most 30 characters long')
      !this.$v.name.required && errors.push('Name is required')
      return errors
    },
    shortNameErrors () {
      const errors = []
      if (!this.$v.shortName.$dirty) return errors
      !this.$v.shortName.maxLength && errors.push('Short name must be at most 10 characters long')
      !this.$v.shortName.required && errors.push('Short name is required')
      return errors
    },
    countriesErrors () {
      const errors = []
      if (!this.$v.countries.$dirty) return errors
      !this.$v.countries.required && errors.push('Countries is required')
      return errors
    }
  },
  mounted: async function () {
    await this.$store.dispatch(COUNTRIES_LIST)
    if (this.distributorInit) {
      this.init(this.distributorInit)
    }
  },
  watch: {
    distributorInit: function (newDistributor) {
      if (newDistributor.name && newDistributor.countries) {
        this.init(this.distributorInit)
      }
    },
    selectAllCheck: function (val) {
      if (val) {
        this.countries = this.countriesList.map(item => item.id)
      } else {
        this.countries = []
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Distributors/Dialog.vue